import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { ChromeTab, Tab } from "@shared/types"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function chromeTabToTab(chromeTab: ChromeTab): Tab {
  return {
    tab_id: chromeTab.id,
    collection_id: "",
    user_id: "",
    title: chromeTab.title,
    url: chromeTab.url,
    favicon_url: chromeTab.favIconUrl || 'https://www.hintword.com/favicon.ico',
    sequence: 0,
    status: "ACTIVE",
    created_at: "",
    updated_at: "",
  }
}

// Returns true if running as a Chrome extension build
export function isChromeExtension() {
  // @ts-ignore
  return typeof __BUILD_TARGET__ !== 'undefined' && __BUILD_TARGET__ === 'chrome';
}
